// actions/schoolAppointmentTypes.js
export const SCHOOL_CREATE_APPOINTMENT_REQUEST = 'SCHOOL_CREATE_APPOINTMENT_REQUEST';
export const SCHOOL_CREATE_APPOINTMENT_SUCCESS = 'SCHOOL_CREATE_APPOINTMENT_SUCCESS';
export const SCHOOL_RESET_APPOINTMENT_STATE = 'SCHOOL_RESET_APPOINTMENT_STATE';